import React from 'react';
import { RecommendedFollowsShape, UserShape } from '../shapes';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import RecommendedUserToFollow from './recommended_user_to_follow';
import PeopleSearchContainer from '../containers/people_search';
import Waiting from './waiting';

export default class FollowRecommendations extends React.Component {

  static propTypes = {
    user: UserShape,
    recommendedFollows: RecommendedFollowsShape,
    onFollow: PropTypes.func,
    onUnFollow: PropTypes.func,
    onReset: PropTypes.func,
    onLoadRecommendedFollows: PropTypes.func,
  }

  componentDidMount() {
    this.props.onReset();
    this.props.onLoadRecommendedFollows();
  }

  render() {
    if (this.props.recommendedFollows.get('loading')) {
      return this.renderLoading();
    } else if (!this.props.user.get('public')) {
      return (
        <Redirect push to={ `/account/make_profile` } />
      )
    }
    else {
      return this.renderRecommendedUsersToFollow();
    }
  }

  renderRecommendedUsersToFollow() {
    const recommendedUsersToFollow = this.props.recommendedFollows.get('recommendedUsers').map((recommendedUserToFollow, i) => {
      return (
        <li key={ i } className='list-group-item'>
          <RecommendedUserToFollow onFollow={ this.props.onFollow } onUnFollow={ this.props.onUnFollow } recommendedUserToFollow={ recommendedUserToFollow } />
        </li>
      );
    });

    if (recommendedUsersToFollow.size > 0) {
      return (
        <div>
          <div className='header'>
            <h2>Find people. Follow people.</h2>
            <p className='item-meta'>
              Follow people to discover new words.
            </p>
          </div>
          <div className='give-me-50'>
            <h4>Search for someone.</h4>
            <PeopleSearchContainer />
          </div>
          <div className='give-me-110'>
            <h4>Or, check out people we think you should follow.</h4>
            <div className='follow-recommendations-group'>
              <ul className='list-group'>{ recommendedUsersToFollow }</ul>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className='header'>
            <h2>People we think you should follow.</h2>
            <p className='item-meta'>
              Follow people to discover new words.
            </p>
          </div>
          <h4>Well, this is awkward. We don't have any recommendations right now.</h4>
        </div>
      )
    }
  }

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/follow_recommendations.jsx